import type CoachService from '@efdigital/ll-xceed-v2/services/coach';
import type PartnershipMessagingService from '@efdigital/ll-xceed-v2/services/partnership-messaging';
import type { CoachingPlanner } from '@efdigital/ll-xceed-v2/utils/coaching/coachee/coaching-plan-manager';
import {
  loadCoacheePartnershipConversations,
  loadCoachPartnershipConversations,
} from '@efdigital/ll-xceed-v2/utils/coaching/load-partnership-conversations';
import { sortConversationsByRecency } from '@efdigital/ll-xceed-v2/utils/coaching/partnership-messages';
import { cohortScopeKey } from '@efdigital/ll-xceed-v2/utils/coaching/scope-key';
import type { Store } from '@warp-drive/core';

// A messaging-sync failure must never fail the route it runs in `afterModel`
// of — it would take down the whole coach/cohort route, not just the
// Messages tab. Log and leave the previous messaging state in place instead.

export async function syncCoachPartnershipMessaging(
  store: Store,
  coach: CoachService,
  coachUserId: string,
  partnershipMessaging: PartnershipMessagingService
): Promise<void> {
  let conversations;
  try {
    conversations = sortConversationsByRecency(
      await loadCoachPartnershipConversations(store, coach, coachUserId)
    );
  } catch (error) {
    console.error(error);
    return;
  }

  partnershipMessaging.sync(conversations, 'coach', 'coach');
}

export async function syncCoacheePartnershipMessaging(
  store: Store,
  planner: CoachingPlanner,
  programId: string,
  cohortId: string,
  partnershipMessaging: PartnershipMessagingService
): Promise<void> {
  let conversations;
  try {
    conversations = sortConversationsByRecency(
      await loadCoacheePartnershipConversations(store, planner)
    );
  } catch (error) {
    console.error(error);
    return;
  }

  partnershipMessaging.sync(
    conversations,
    'coachee',
    cohortScopeKey(programId, cohortId)
  );
}
